
import React, { useEffect, useState } from 'react';

import { CircularProgress } from '@mui/material';
const Month_start = () => {
  const [data, setData] = useState({});
  const [details, setDetails] = useState(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    fetch(`${process.env.REACT_APP_URL_MIS}/api/dkrreport/monthStart`)
      .then(res => res.json())
      .then(setData)
      .catch(console.error);
  }, []);

  const fetchDetails = (id) => {
    setLoading(true);
    let url;
    if (id === 'N' || id === 'O') {
      url = `${process.env.REACT_APP_URL_MIS}/api/dkrreport/newOldShops?status=${id}`;
    } else if (id === 'L') {
      url = `${process.env.REACT_APP_URL_MIS}/api/dkrreport/lessCardsShops`;
    } else if (id === 'R') {
      url = `${process.env.REACT_APP_URL_MIS}/api/dkrreport/notSeededRc`;
    } else {
      url = `${process.env.REACT_APP_URL_MIS}/api/dkrreport/zeroAllocationShops?status=${id}`;
    }
    fetch(url)
      .then(res => res.json())
      .then(setDetails)
      .catch(console.error)
      .finally(() => setLoading(false));
  };

  const monthName = data.monthName || '';
  const year = data.year || '';
  const hasDetails = details && details.items && details.items.length > 0;

  const getTableWidth = () => {
    if (!details) return '100%';
    if (details.type === 'notseeded') {
      return '50%';
    } else if (details.type === 'less') {
      return '80%';
    } else if (details.type === 'newold' || details.type === 'zero') {
      return '100%';
    }
    return '100%';
  };

  return (
    <>
      <br />
      <table align="center" width="50%" border="1">
        <tr className="tableheader">
          <td colSpan="2">Status of EPOS implementation <br/>for the month
          of {monthName} / {year} from FEAST</td>
        </tr>
        <tr>
          <td>Number of Districts</td>
          <td align="right">{data.totalDistricts || '0'}</td>
        </tr>
        <tr>
          <td>Number of Cards</td>
          <td align="right">{data.present || '0'}</td>
        </tr>
        <tr>
          <td>Number of Members</td>
          <td align="right">{data.noOfUnits || '0'}</td>
        </tr>
        <tr>
          <td> &nbsp; <font style={{color: 'red', fontWeight: 'bold'}}>(A)</font> &nbsp;&nbsp; Number of Shops with Cards </td>
          <td align="right">{data.presentTotalShops || '0'}</td>
        </tr>
        <tr>
          <td> &nbsp; <font style={{color: 'red', fontWeight: 'bold'}}>(B)</font> &nbsp;&nbsp; Number of ePos Shops (Device Mapped) </td>
          <td align="right">{data.mapped || '0'}</td>
        </tr>
        <tr>
          <td> &nbsp; <font style={{color: 'red', fontWeight: 'bold'}}>(A-B)</font> Number of Non-ePos Shops (Device Not Mapped) </td>
          <td align="right">{data.notMapped || '0'}</td>
        </tr>
        <tr>
          <td>Number of ePos Shops without Dealer Mapping</td>
          <td align="right">{data.noDealer || '0'}</td>
        </tr>
        <tr>
          <td>Last month Shops not available this month</td>
          <td align="right">
            <a style={{cursor: 'pointer'}} onClick={() => fetchDetails('O')}>{data.oldShops || '0'}</a></td>
        </tr>
        <tr>
          <td>New Shops added this month</td>
          <td align="right">
            <a style={{cursor: 'pointer'}} onClick={() => fetchDetails('N')}>{data.newShops || '0'} </a></td>
        </tr>
        <tr>
          <td>Difference of Cards between previous and current month</td>
          <td align="right">{data.diffCards || '0'}</td>
        </tr>
        <tr>
          <td>ePos Shops with Zero allocation</td>
          <td align="right">{data.zeroAlot || '0'}</td>
        </tr>
        <tr>
          <td>UID Not Mapped Members</td>
          <td align="right">{data.noUid || '0'}</td>
        </tr>
        <tr>
          <td>Name not Available Members</td>
          <td align="right">{data.noName || '0'}</td>
        </tr>
        <tr>
          <td>Less than {data.checkConn || ''} Cards FPS <font style={{fontSize:'15px', color: 'red', fontWeight: 'bold'}}>*</font></td>
          <td align="right"><a style={{cursor: 'pointer'}} onClick={() => fetchDetails('L')}>{data.lessCards || '0'}</a></td>
        </tr>
        <tr>
          <td>Not Seeded RC's<font style={{fontSize:'15px', color: 'red', fontWeight: 'bold'}}>*</font></td>
          <td align="right"><a style={{cursor: 'pointer'}} onClick={() => fetchDetails('R')}>{data.notSeeded || '0'}</a></td>
        </tr>
      </table>
      <br/><br/>
      <table align="center" width="50%" border="1">
        <tr align="center" className="tableheader">
          <td>Commodity Name</td>
          <td>Zero Allocation Shops</td>
          <td>Total Allocation <br /> For all FPS in KG
          </td>
        </tr>
        {(data.list2 || []).map((item, idx) => (
          <tr key={idx}>
            <td>{item.commodityNameEn}</td>
            <td align="right">{item.zeroAllocation}</td>
            <td align="right">{item.totalAllotment}</td>
          </tr>
        ))}
      </table>
      <div align="center" id="loading" style={{display: loading ? 'block' : 'none'}}>
         <CircularProgress/>
      </div>
      
      <br />
      {details && (
        hasDetails ? (
          <table align="center" width={getTableWidth()} border="1">
            {details.type === 'newold' && (
              <>
                <tr className="tableheader">
                  <td colSpan="8">{details.status === 'N' ? 'List Of shops Newly Came in Current Month' : 'List Of shops Not Available in Current Month'}</td>
                </tr>
                <tr className="tableheader">
                  <td>Sl No</td>
                  <td>District</td>
                  <td>office</td>
                  <td>FPS</td>
                  <td>Total Cards</td>
                  <td>No Of Members</td>
                 <td>{details.status === 'N' ? ( <span> Wheat Allotment <br /> units in KG </span>
                   ) : (
                   <span>Wheat CB <br /> units in KG</span>
                )}</td>
 <td>Mapping Status</td>
                </tr>
                {details.items.map((item, idx) => (
                  <tr key={idx}>
                    <td>{idx + 1}</td>
                    <td>{item.dist_name_en}</td>
                    <td>{item.afso_name_en}</td>
                    <td>{item.fps_id}</td>
                    <td align="right">{item.total_cards}</td>
                    <td align="right">{item.total_units}</td>
                    <td align="right">{item.cb}</td>
                    <td align="right">{item.to_fps_id}</td>
                  </tr>
                ))}
              </>
            )}
            {details.type === 'less' && (
              <>
                <tr className="tableheader">
                  <td colSpan="6">Less than <font style={{color: 'orange'}}>{data.checkConn}</font> Cards FPS in <font style={{color: 'orange'}}>{monthName}'{year}</font></td>
                </tr>
                <tr className="tableheader">
                  <td>Sl No</td>
                  <td>District</td>
                  <td>office</td>
                  <td>FPS</td>
                  <td>Total<br/>Cards</td>
                  <td>No Of<br/>Members</td>
                </tr>
                {details.items.map((item, idx) => (
                  <tr key={idx}>
                    <td>{idx + 1}</td>
                    <td>{item.dist_name_en}</td>
                    <td>{item.office_name_en}</td>
                    <td>{item.fps_id}</td>
                    <td align="right">{item.total_cards}</td>
                    <td align="right">{item.total_units}</td>
                  </tr>
                ))}
              </>
            )}
            {details.type === 'notseeded' && (
              <>
                <tr className="tableheader">
                  <td colSpan="3">Not Seeded RC's Abstract</td>
                </tr>
                <tr className="tableheader">
                  <td>Sl No</td>
                  <td>office</td>
                  <td>RC Count</td>
                </tr>
                {details.items.map((item, idx) => (
                  <tr key={idx}>
                    <td>{idx + 1}</td>
                    <td>{item.officeName}</td>
                    <td align="right">{item.rcCount}</td>
                  </tr>
                ))}
              </>
            )}
            {details.type === 'zero' && (
              <>
                <tr className="tableheader">
                  <td colSpan="7">List Of shops Those {details.commodityNameEn} Allocation is Zero </td>
                </tr>
                <tr className="tableheader">
                  <td>Sl No</td>
                  <td>District</td>
                  <td>office</td>
                  <td>FPS</td>
                  <td>Total Cards</td>
                  <td>No Of Members</td>
                  <td>Opening Balance</td>
                </tr>
                {details.items.map((item, idx) => (
                  <tr key={idx}>
                    <td>{idx + 1}</td>
                    <td>{item.dist_name_en}</td>
                    <td>{item.afso_name_en}</td>
                    <td>{item.fps_id}</td>
                    <td align="right">{item.total_cards}</td>
                    <td align="right">{item.total_units}</td>
                    <td align="right">{item.ob}</td>
                  </tr>
                ))}
              </>
            )}
          </table>
        ) : (
          <div align="center" className="response">No Data Found</div>
        )
      )}
      <br /><br /><br /><br />
      <br /><br /><br /><br />
      <br /><br /><br /><br />
    </>
  );
};

export default Month_start;